import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "@/components/layout/DashboardLayout";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import StatusBadge from "@/components/StatusBadge";
import { fileUrl } from "@/lib/files";
import { Package } from "lucide-react";

export default function SupplierProducts() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/supplier/products").then((r) => setItems(r.data)).catch(()=>{}); }, []);
  const filtered = items.filter((p) => !q || p.name.toLowerCase().includes(q.toLowerCase()) || p.category.toLowerCase().includes(q.toLowerCase()));
  return (
    <DashboardLayout title="My products" actions={<Link to="/supplier/products/new"><Button data-testid="new-product-btn">+ New product</Button></Link>}>
      <div className="mb-6"><Input data-testid="search-products" placeholder="Search products…" value={q} onChange={(e)=>setQ(e.target.value)} className="max-w-sm" /></div>
      {filtered.length === 0 ? (
        <Card><CardContent className="py-16 text-center">
          <Package className="w-10 h-10 text-muted-foreground mx-auto" />
          <div className="mt-3 text-secondary font-heading font-semibold">No products yet</div>
          <p className="text-sm text-muted-foreground mt-1">Create your first product to submit it for review.</p>
          <Link to="/supplier/products/new"><Button className="mt-4" data-testid="empty-new-product">+ Create product</Button></Link>
        </CardContent></Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {filtered.map((p) => (
            <Link to={`/supplier/products/${p.id}`} key={p.id} className="bg-white border border-border rounded-lg overflow-hidden card-lift" data-testid={`product-card-${p.id}`}>
              <div className="aspect-[16/9] bg-muted grid place-items-center overflow-hidden">
                {p.image_urls?.[0] || p.image_ids?.[0] ? <img src={p.image_urls?.[0] || fileUrl(p.image_ids[0])} alt={p.name} className="w-full h-full object-cover" /> : <Package className="w-10 h-10 text-muted-foreground" />}
              </div>
              <div className="p-5">
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-heading font-bold text-secondary truncate">{p.name}</div>
                    <div className="text-xs text-muted-foreground mt-0.5">{p.category} · {p.origin_country}</div>
                  </div>
                  <StatusBadge status={p.status} />
                </div>
                <p className="mt-3 text-sm text-muted-foreground line-clamp-2">{p.description}</p>
                <div className="mt-4 text-xs text-muted-foreground">MOQ: {p.moq} {p.unit} · Price: {p.price_min ? `${p.price_min}–${p.price_max || "?"} ${p.currency}` : "on request"}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
